var path = 'src/app/components/common/day-of-week/day-of-week.template.html';
var html = "<select\n  ng-model=\"$ctrl.value\"\n  ng-required=\"$ctrl.required\"\n  ng-options=\"o.value as o.label for o in $ctrl.days\">\n</select>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;